import { Checkbox, FormControlLabel } from "@mui/material";
import { Controller } from "react-hook-form";

const ControlledFormCheckbox = ({
  checkboxProps,
  control,
  defaultValue,
  id,
  label,
  name,
  readonly,
  trigger,
  ...props
}) => {
  return (
    <Controller
      control={control}
      defaultValue={defaultValue}
      name={name}
      render={({ field: { onChange, ref, value } }) => (
        <FormControlLabel
          checked={
            Array.isArray(value)
              ? value.includes(props.value)
              : value === props.value
          }
          control={<Checkbox name={name} {...checkboxProps} />}
          disabled={!!readonly}
          id={id}
          inputRef={ref}
          label={label}
          onChange={(e) => {
            onChange(e.target.checked ? props.value : e);
            trigger && trigger();
          }}
          sx={{
            fontSize: "1em",
            marginX: label ? undefined : "0",
            width: label ? "15em" : undefined,
          }}
          value={props.value}
          {...props}
        />
      )}
    />
  );
};
export { ControlledFormCheckbox };
